export default __webpack_public_path__ + "static/media/student.c2d1f6b9.svg";